import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';

let titleSceneK: any = null;
export default function G() {
    const { useLang, useRouter, useEffect, useState, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('delta_pro_ultra.launch.detail.SHP2');
    const [textEnter, setTextEnter] = useState(false);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const resizeAni = () => {
                if (titleSceneK) {
                    AniContainer.removeScene(titleSceneK);
                    titleSceneK = null;
                }

                // maskSceneC = AniContainer.create({
                //     asyncFromTo: [['.shp2-detail-K .mask', { opacity: 0 }, { opacity: 1 }]],
                //     triggerElement: '.shp2-detail-K',
                //     triggerHook: 1,
                //     offset: window.innerHeight,
                //     duration: window.innerHeight / 2,
                // });

                // titleSceneK = AniContainer.create({
                //     asyncFromTo: [['.shp2-detail-K .title', { opacity: 0, y: window.innerHeight / 4 }, { opacity: 1, y: 0 }]],
                //     triggerElement: '.shp2-detail-K',
                //     triggerHook: 1,
                //     offset: window.innerHeight * 1.5,
                //     duration: window.innerHeight / 2,
                // });
                const clientH = (window.innerHeight || 0) * 0.2;
                const startH = Math.min(clientH, 150);
                titleSceneK = AniContainer.create({
                    triggerElement: '.shp2-detail-K .sticky-box',
                    triggerHook: 1,
                    offset: '40%',
                    duration: 200,
                    onEnter: () => {
                        setTextEnter(true);
                    },
                    //onLeave: () => setTextEnter(false),
                });
            };
            resizeAni();
            //window.addEventListener('resize', resizeAni);
            return () => {
                if (titleSceneK) {
                    AniContainer.removeScene(titleSceneK);
                    titleSceneK = null;
                }
                // window.removeEventListener('resize', resizeAni);
            };
        }
    }, []);

    return (
        <section id="shp2-detail-K" className={`shp2-detail-K shp2-detail-section ${css['shp2-detail-K']}`}>
            <div className={`sticky-box ${textEnter ? 'enter' : ''}`}>
                <div className="img-box">
                    <EFPicture src={'/responsive/picture/smart-home-panel-2/launch/11.jpg'} alt={t('secK_title')} />
                    <div className="mask"></div>
                    <div className="title-box">
                        <h2 className="title">{t('secK_title')}</h2>
                    </div>
                </div>
            </div>
        </section>
    );
}
